module.exports = new __parcel__URL__("TeamAppTile.265b8d3b.svg").toString();